/**
 * Browser logger: timestamped, levelled lines in the developer console.
 *
 * Level comes from REACT_APP_LOG_LEVEL (error | warn | info | debug), read
 * from the runtime config (window._env_) first, then the build env.
 * Default: debug in development builds, warn in production builds.
 */
const LEVELS = { error: 0, warn: 1, info: 2, debug: 3 };

const configuredLevel = () => {
  const value = (window?._env_?.REACT_APP_LOG_LEVEL || process.env.REACT_APP_LOG_LEVEL || "").toLowerCase();
  if (value in LEVELS) return value;
  return process.env.NODE_ENV === "development" ? "debug" : "warn";
};

const write = (level, message, ...details) => {
  if (LEVELS[level] > LEVELS[configuredLevel()]) return;
  const line = `${new Date().toISOString()} ${level}: ${message}`;
  // eslint-disable-next-line no-console
  (console[level] || console.log)(line, ...details);
};

const logger = {
  error: (message, ...details) => write("error", message, ...details),
  warn: (message, ...details) => write("warn", message, ...details),
  info: (message, ...details) => write("info", message, ...details),
  debug: (message, ...details) => write("debug", message, ...details),
};

export default logger;
